import { Component, Input, SimpleChanges, ViewChild } from '@angular/core';
import {
  QaiTabsComponent,
  QaiTabDirective,
  QaiInnerWrapComponent,
  QaiLoadingComponent,
} from '@qai/ui';
import { PracticeTabComponent } from './practice-tab/practice-tab.component';
import { CertificationTabComponent } from './certification-tab/certification-tab.component';
import {
  TRANSLOCO_SCOPE,
  TranslocoModule,
  TranslocoService,
} from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { CommonModule } from '@angular/common';
import { ReportingLocalStorageUtil } from 'src/app/utils/reporting-localstorage.util';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';

@Component({
  selector: 'app-assignments-tab',
  templateUrl: './assignments-tab.component.html',
  styleUrls: ['./assignments-tab.component.scss'],
  standalone: true,
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: 'reportingV2',
    },
  ],
  imports: [
    QaiTabsComponent,
    QaiTabDirective,
    PracticeTabComponent,
    CertificationTabComponent,
    QaiInnerWrapComponent,
    TranslocoModule,
    CommonModule,
    QaiLoadingComponent
  ],
})
export class AssignmentsTabComponent {
  @Input() selectedAccount: { label: string; value: string } | null = null;
  @Input() selectedTeams: string[] = [];
  @Input() isTeamAvailable: boolean = false;
  @Input() isLoading: boolean = false;
  @Input() isNetworkCallInprogress: boolean = false;
  @ViewChild('tabsComponent') tabsComponent!: QaiTabsComponent;
  activeTab = '';
  isTranslationLoaded: boolean = false;

  constructor(
    private translocoService: TranslocoService,
    private translationService: TranslationService,
    private amplitudeService: AmplitudeService
  ) { }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectedAccount']) {
      console.log(
        'selectedAccount changed in assignments tab:',
        changes['selectedAccount'].currentValue
      );
    }
    if (changes['selectedTeams']) {
      console.log(
        'selectedTeams changed in assignments tab:',
        changes['selectedTeams'].currentValue
      );
    }
  }

  ngOnInit() {
    this.translationService.loadScopedTranslation('reportingV2').then(() => {
      this.isTranslationLoaded = true;
      const storedAssignmentTab = this.getStoredTab();
      console.log('storedAssignmentTab:', storedAssignmentTab);

      if (storedAssignmentTab) {
        this.activeTab = storedAssignmentTab;
        setTimeout(() => {
          this.selectTab(storedAssignmentTab);
        }, 100);
      } else {
        console.log('No stored tab found, using default practice tab');
        this.activeTab = this.translocoService.translate(
          'PRACTICE_LABEL',
          {},
          'reportingV2'
        );
        this.setStoredTab(this.activeTab);
      }
    });
  }

  onTabChange(event: any): void {
    // Accept both string and event object
    const tabId =
      typeof event === 'string'
        ? event
        : event?.detail?.tabId || event?.tabId || '';
    if (tabId) {
      this.activeTab = tabId;
      this.setStoredTab(tabId);
      console.log('Active tab changed to:', tabId);

      // Track tab click events
      if (tabId === 'practice') {
        this.amplitudeService.trackEvent(AmplitudeTrackingEvents.REPORTINGDASHBOARD_CLICK_PRACTICETAB);
      } else if (tabId === 'certification') {
        this.amplitudeService.trackEvent(AmplitudeTrackingEvents.REPORTINGDASHBOARD_CLICK_CERTIFICATIONTAB);
      }
    }
  }

  selectTab(storedTabId: string) {
    if (this.tabsComponent) {
      this.tabsComponent.selectTabById(storedTabId);
    } else {
      console.log('tabsComponent not available yet');
    }
  }

  getStoredTab() {
    return ReportingLocalStorageUtil.getStoredAssignmentTab();
  }

  setStoredTab(tabId: string) {
    ReportingLocalStorageUtil.setStoredAssignmentTab(tabId);
  }
}
